import { combineEpics } from 'redux-observable';
import {
    pushUpcomingApptsEpic,
    clearUpcomingApptEpic,
    skeletonUpcomingApptsReset
} from './upcomingappointments/src/index';
import {
    fetchApptsEpic,
    pushApptsTableEpic,
    pushCancelApptToEpic,
    pushConfirmApptToEpic,
    clearAppointmentsEpic,
    pushUpdateApptToEpic,
    clearAppointmentsonPatientChangeEpic
} from './appointments/src/index';
import {
    fetchDashboardApi
} from './dashboard/src/index';
import {
    pushPendingBillsToState,
    clearPendingBillsEpic
} from './pendingbills/src/index';
import {
    fetchCallingDest,
    clearCalledDestination
} from './calleddest/src/index';
import {
    fetchPharmacyEpic,
    clearPharmacyEpic
} from './pharmacies/src/index';
import {
    fetchCallerDetailsFromDB, pushPatientDataToCaller,
    pushSelectedPatientDataToCaller, fetchSouceTypeToCaller,
    fetchSelectedSouceTypeToCaller, clearSourceEpic,
    clearSourceTypeEpic, setSourceAsItIsSubject
} from './source/src/index';
import {
    fetchPatientsEpic,
    selectDrawer,
    healthAlert,
    fetchConsolidatedAPIOneEpic,
} from './subject/src/index';
import {
    fetchPendingRefEpic,
    clearPendingRefEpic
} from './pendingreferrals/src/index';
import {
    fetchPCPEpic,
    clearPCPEpic,
    clearErrorEpic
} from './pcp/src/index';
import { fetchScreenpopEpic } from './screenpop/src/index';
import { fetchReceiveCommunicationEpic } from './receivecommunication/src/index';
import {
    setCallerDetailsFromAddNew,
    pushAddNewDataToCaller,
    checkForAddNewNotification,
    pushAddNewSelectedSouceTypeToCaller,
    pushAddNewSelectedPatientDataToCaller,
} from './addnew/src/index';

import {
    fetchAllergiesEpic, clearAllergiesEpic
} from './activeallergies/src/index';

import {
    fetchActiveProblemEpic, clearActiveProblemEpic
} from './activeproblems/src/index';

import {
    fetchMedicalHistoryEpic, clearMedicalHistoryEpic
} from './medicalhistory/src/index';

import {
    fetchPatientsGlobalSearchEpic,
    resetSpinForPateintGlobalSearchEpic,
} from './patientglobalsearch/src/index';
import {
    fetchPatientsGlobalSearchCerner,
    resetSpinForPateintGlobalSearchCerner,
} from './cerner-epics/patientglobalsearch/src/index';
import {
    fetchProvidersGlobalSearchEpic,
    resetSpinForProviderGlobalSearchEpic,
} from './providerglobalsearch/src/index';

import {
    pushCallRecord,
} from './pushcallrecord/src/index';

import {
    storeDispositionCode
} from './dispositionstore/src/index';

import {
    clearSkeletonEpic,
} from './skeleton/src/index';

import {
    clearChooseCallerEpic,
} from './choosecaller/src/index';

import {
    fetchBillingDetailsFromEpic,
    pushBillingDetailsToState,
    pushSelectedBillingData,
    clearBillingEpic
} from './billing/src/index';

import {
    fetchInsuranceDetailsFromEpic,
    pushSelectedInsuranceData,
    clearInsuranceEpic,
    fetchFHIRDetailsFromEpic,
    clearFHIRInsuranceEpic
} from './insurance/src/index';


import {    
    fetchPrescriptionEpic, 
    pushClearPrescription
} from './prescription/src/index';

import {
    fetchMedicationEpic,
    clearMedicationEpic
} from "./medication/src/index";

import {
    fetchOrdersRefEpic,
    clearOrdersRefEpic
} from "./orders/src/index";

import {
    fetchIdentifiersEpic,
    clearIdentifierEpic
} from './patientidentifier/src/index'

import {
    fetchEpicUserID
} from './getuserid/src/index';

import {
    fetchUpdateUserID
} from './updateuserid/src/index';

import {
    fetchServiceNowCallerEpic,
    clearSNCallerDetailsEpic
} from './servicenow_callerdetails/src/index';

import {
    fetchIncidentsEpic,
    clearIncidentsEpic
} from './incidents/src/index';

import {
    fetchInteractionsEpic,
    clearInteractionsEpic
} from './interactions/src/index';

import {
    fetchCreateInteractionsEpic
} from './create-interactions/src/index'

import {
    fetchCreateIncidentsEpic
} from './create-incidents/src/index';

import {
    fetchUpdateIncidentsEpic,
    clearUpdateIncidentEpic
} from './update-incidents/src/index';

import {
    fetchLinkedIncidentsEpic
} from './linkedincidents/src/index';

import {
    fetchPatientSearchInfo,
    clearPatientSearchEpic
} from "./btgpatientepic/src/index";

import {
    fetchSetSessionEpic, clearSetSessionEpic
} from './setssession-epic/src/index';

import {
    fetchGetSessionEpic, clearGetSessionEpic, clearSelectedSourceSessionEpic, clearSelectedSubSessionEpic
} from './getsession-epic/src/index';

import {
    fetchEndSessionEpic, clearEndSessionEpic
} from './endsession-epic/src/index';

import { 
    fetchPatientsCerner 
} from './cerner-epics/subject/src';
import {
fetchPatientSearchInfo_Cerner,clearPatientSearchCerner
} from './cerner-epics/btgpatientcerner/src/index';
import {fetchApptsCerner,pushApptsTableCerner,clearAppointmentsCerner,clearAppointmentsonPatientChangeCerner,pushCancelApptToCerner} from './cerner-epics/appointments/src/index';
import {fetchPCPCerner,clearErrorCerner,clearPCPCerner} from "./cerner-epics/pcp/src/index"
import {fetchPendingRefCerner,clearPendingRefCerner} from "./cerner-epics/pendingreferrals/src/index";
import {fetchBillingDetailsFromCerner,pushBillingDetailsToStateCerner,clearBillingCerner,pushSelectedBillingDataCerner} from "./cerner-epics/billing/src/index"
import {fetchInsuranceDetailsFromCerner,clearInsuranceCerner,clearFHIRInsuranceCerner} from "./cerner-epics/insurance/src/index";
import {fetchPharmacyCerner} from "./cerner-epics/pharmacies/src/index";
import {fetchMedicalHistoryCerner,clearMedicalHistoryCerner} from "./cerner-epics/medicalhistory/src/index";
import {pushUpcomingApptsCerner,clearUpcomingApptCerner} from "./cerner-epics/upcomingappointments/src/index";
import {fetchAllergiesCerner} from "./cerner-epics/activeallergies/src/index";
import {fetchMedicationCerner,clearMedicationCerner} from "./cerner-epics/medication/src/index";
import {
    pushPendingBillsToStateCerner,
    clearPendingBillsCerner
} from './cerner-epics/pendingbills/src/index';


import {
    fetchPatientsAthena 
} from './athena-epics/subject/src';

import { 
    clearErrorAthena, 
    clearPCPAthena, 
    fetchPCPAthena 
} from './athena-epics/pcp/src';

import {
    fetchApptsAthena,
    pushApptsTableAthena,
    clearAppointmentsAthena,
    clearAppointmentsonPatientChangeAthena,
    pushCancelApptToAthena,
    pushConfirmApptToAthena
} from './athena-epics/appointments/src';
    
import {
    fetchInsuranceDetailsFromAthena,
    clearInsuranceAthena
} from './athena-epics/insurance/src';
import {
    pushUpcomingApptsAthena,
    clearUpcomingApptAthena
} from './athena-epics/upcomingappointments/src';

import { fetchPendingRefAthena } from './athena-epics/pendingreferrals/src';
import {
    fetchProviderInfoAthena
} from './athena-epics/getproviderinfo/src';

import {
    fetchGetDeptInfoAthena,
    clearGetDeptInfoAthena
} from './athena-epics/getdeptinfo/src';

import {
    fetchGetAllDepartmentsAthena
} from './athena-epics/getalldepartments/src';

import {
    fetchGetAllProvidersAthena
} from './athena-epics/getallproviders/src';

import {
    fetchGetAllVisitTypesAthena
} from './athena-epics/getvisittypes/src';

import {
    fetchGetAllTimeSlotsAthena
} from './athena-epics/gettimeslots/src';

import {
    fetchRescheduleAppointmentAthena
} from './athena-epics/rescheduleappointment/src';


import {
fetchGetApptReasonAthena,
clearApptReasonAthena
} from './athena-epics/getapptreasoncodes/src';

import { 
    addNotesHistoryEpic, 
    clearNotesEpic, 
    fetchNotesHistoryEpic 
} from './notes-history/src';

import { 
    fetchReportResultEpic, 
    runReportEpic 
} from './call-history/src/index';

import {
    fetchPatientsGlobalSearchAthena,
    resetSpinForPateintGlobalSearchathena
} from './athena-epics/patientglobalsearch/src/index'

import {niceClickToTransfer} from './niceclicktocall/src/index';

import {
    fetchLiveSearchEpic
} from './panviva_epic/src/index'; 

import { 
    clearMedicationAthena, 
    fetchMedicationAthena 
} from './athena-epics/medication/src';

import {
    fetchPanvivaUserID
} from './getpanvivaid/src/index';

import {
    fetchUpdatePanvivaID
} from './updatepanvivaid/src/index';
import { 
    clearPharmacyAthenaEpic, 
    fetchPharmacyAthenaEpic 
} from './athena-epics/pharmacies/src';

import {
    fetchRefillEpic
} from './refill-epic/src/index';

import { 
    clearAllergiesAthena, 
    fetchAllergiesAthena 
} from './athena-epics/activeallergies/src';

import { 
    clearMedicalHistoryAthena, 
    fetchMedicalHistoryAthena 
} from './athena-epics/medicalhistory/src';

import { 
    clearActiveProblemAthena, 
    fetchActiveProblemAthena 
} from './athena-epics/activeproblems/src';

import { 
    clearBillingAthena, 
    fetchBillingDetailsFromAthena,
    pushBillingDetailsToStateAthena,
    pushSelectedBillingDataAthena, 
} from './athena-epics/billing/src';

import{
    clearPendingBillsAthena,
    pushPendingBillsToStateAthena
} from './athena-epics/pendingbills/src';

/**
 * 
 * meditech epics
 */
import {
    fetchPatientsMeditech 
} from './meditech-epics/subject/src';

import {
fetchMedicationMeditech
} from './meditech-epics/medication/src';

import {
    fetchPatientsGlobalSearchMeditech,
    resetSpinForPateintGlobalSearchMeditech
} from './meditech-epics/patientglobalsearch/src'
import {
    fetchApptsMeditech,
    pushConfirmApptToMeditech,
    pushApptsTableMeditech,pushCancelApptToMeditech
} from './meditech-epics/appointments/src'
import {fetchPCPMeditech,clearErrorMeditech,clearPCPMeditech} from "./meditech-epics/pcp/src/index"

import {
    pushUpcomingApptsMeditech,clearUpcomingApptMeditech
} from './meditech-epics/upcomingappointments/src'
/**
 * 
 * nextgen epics
 */
import {
    fetchPatientsNextgen 
} from './nextgen-epics/subject/src';

import {
    fetchPatientsGlobalSearchNextgen,
    resetSpinForPateintGlobalSearchNextgen
} from './nextgen-epics/patientglobalsearch/src'
import { clearPCPNextgen, fetchPCPNextgen } from './nextgen-epics/pcp/src';
import {fetchApptsNextgen,pushApptsTableNextgen} from './nextgen-epics/appointments/src'
import {
    pushUpcomingApptsNextgen,
    clearUpcomingApptNextgen
} from './nextgen-epics/upcomingappointments/src';

import {
    fetchBillingDetailsFromNextGen,
    pushBillingDetailsToStateNextGen,
    pushSelectedBillingDataNextGen,
    clearBillingNextGen
    } from './nextgen-epics/billing/src';

import {
pushPendingBillsToStateNextGen
} from './nextgen-epics/pendingbills/src'

import {
fetchAlertsNextGen
} from './nextgen-epics/alerts/src'
import {
    fetchAllergiesNextgen, clearAllergiesNextgen
} from './nextgen-epics/activeallergies/src/index';

import {fetchMedicationNextgen,clearMedicationNextgen} from './nextgen-epics/medication/src/index'
import {fetchEmergencyContactNextgen,clearEmergencyContactNextgen} from "./nextgen-epics/emergencycontact/src/index";
import {fetchInsuranceDetailsFromNextgen} from './nextgen-epics/insurance/src/index'

import { fetchPatientsECW } from './ecw-api/subject/src/index'
import { fetchPatientsGlobalSearchECW, resetSpinForPateintGlobalSearchecw } from './ecw-api/patientglobalsearch/src/index';
/**
 * This Function will add all the active epics
 * @param context contains setting json etc..
 */

const activeepics = (context: any) => {

    const { settings } = context;
    const { 
        uisettings: { 
            tabconfig, 
            search,
            callingdestinationcard,
            btg_config, 
            consolidated_api_invocation,
            dashboardapiconfig,
            dashboardcardconfig  
        } 
    } = settings;


    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicarray: any = [];

    if(consolidated_api_invocation)
    {
        epicarray.push(fetchDashboardApi(context));
    }
    epicarray.push(fetchApptsEpic(context));
    epicarray.push(pushApptsTableEpic(context));
    epicarray.push(pushCancelApptToEpic(context));
    epicarray.push(pushConfirmApptToEpic(context));
    epicarray.push(pushUpdateApptToEpic(context));
    epicarray.push(clearAppointmentsEpic(context));
    epicarray.push(clearAppointmentsonPatientChangeEpic(context));
    epicarray.push(pushUpcomingApptsEpic(context));
    epicarray.push(clearUpcomingApptEpic(context));
    epicarray.push(pushPendingBillsToState(context));
    epicarray.push(clearPendingBillsEpic(context));
    epicarray.push(skeletonUpcomingApptsReset(context));
    if(dashboardapiconfig?.getcallerdetails) {
        epicarray.push(fetchCallerDetailsFromDB(context));
    }
    epicarray.push(setSourceAsItIsSubject(context));
    epicarray.push(fetchEpicUserID(context));
    epicarray.push(fetchUpdateUserID(context));
    //commented 2 lines not to push patient caller data to source
    // epicarray.push(pushPatientDataToCaller(context));
    // epicarray.push(pushSelectedPatientDataToCaller(context));
    if(callingdestinationcard) {
        epicarray.push(fetchCallingDest(context));
        epicarray.push(clearCalledDestination(context));
    }
    epicarray.push(fetchSouceTypeToCaller(context));
    epicarray.push(fetchSelectedSouceTypeToCaller(context));
    epicarray.push(fetchPatientsEpic(context));
    epicarray.push(fetchPendingRefEpic(context));
    epicarray.push(clearPendingRefEpic(context));
    //epicarray.push(selectPatientsEpic(context));
    epicarray.push(selectDrawer(context));
    epicarray.push(healthAlert(context));
    if(consolidated_api_invocation)
    {
        epicarray.push(fetchConsolidatedAPIOneEpic(context));
    }
    if(dashboardapiconfig?.getpcp) {
        epicarray.push(fetchPCPEpic(context));
        epicarray.push(clearPCPEpic(context));
    }

    //check for Pharmacy tab is enabled or not
    if(dashboardcardconfig.pharmacies) {
        epicarray.push(fetchPharmacyEpic(context));
        epicarray.push(clearPharmacyEpic(context));
    }
    epicarray.push(fetchScreenpopEpic(context));
    epicarray.push(fetchReceiveCommunicationEpic(context));
    epicarray.push(setCallerDetailsFromAddNew(context));
    epicarray.push(pushAddNewDataToCaller(context));
    epicarray.push(checkForAddNewNotification(context));
    epicarray.push(pushAddNewSelectedSouceTypeToCaller(context));
    epicarray.push(pushAddNewSelectedPatientDataToCaller(context));
    epicarray.push(fetchBillingDetailsFromEpic(context));
    epicarray.push(pushBillingDetailsToState(context));
    epicarray.push(pushSelectedBillingData(context));
    epicarray.push(clearBillingEpic(context));
    epicarray.push(fetchInsuranceDetailsFromEpic(context));
    epicarray.push(fetchFHIRDetailsFromEpic(context));
    epicarray.push(pushSelectedInsuranceData(context));
    epicarray.push(clearInsuranceEpic(context));
    epicarray.push(clearSourceEpic(context));
    epicarray.push(clearSourceTypeEpic(context));
    epicarray.push(clearErrorEpic(context));
    epicarray.push(clearSkeletonEpic(context));
    epicarray.push(clearChooseCallerEpic(context));
    epicarray.push(fetchIdentifiersEpic(context));
    epicarray.push(clearIdentifierEpic(context));
    epicarray.push(clearFHIRInsuranceEpic(context));
    // check for the patient global search is enbaled
    if (search.patient) {
        epicarray.push(fetchPatientsGlobalSearchEpic(context));
        epicarray.push(resetSpinForPateintGlobalSearchEpic(context));
    }
    // check for the provider global search is enbaled
    if (search.patient) {
        epicarray.push(fetchProvidersGlobalSearchEpic(context));
        epicarray.push(resetSpinForProviderGlobalSearchEpic(context));
    }
    // check for the traige tab enabled or not
    if (tabconfig.triage) {
        epicarray.push(fetchAllergiesEpic(context));
        epicarray.push(clearAllergiesEpic(context));
        epicarray.push(fetchActiveProblemEpic(context));
        epicarray.push(clearActiveProblemEpic(context));
        epicarray.push(fetchMedicalHistoryEpic(context));
        epicarray.push(clearMedicalHistoryEpic(context));
    }
    //check for Medication tab is enabled or not
    if(tabconfig.medication) {
        epicarray.push(fetchMedicationEpic(context));
        epicarray.push(clearMedicationEpic(context));
    }
    if(tabconfig.orders) {
        epicarray.push(fetchOrdersRefEpic(context));
        epicarray.push(clearOrdersRefEpic(context));
    }
    //check for prescription Prescription 
    if(tabconfig.prescription) {
        epicarray.push(fetchPrescriptionEpic(context));
        epicarray.push(pushClearPrescription(context));
        epicarray.push(fetchRefillEpic(context));
    }

    //check for ServiceNow 
    if(tabconfig.servicenow) {
        epicarray.push(fetchServiceNowCallerEpic(context));
        epicarray.push(fetchCreateIncidentsEpic(context));
        epicarray.push(fetchLinkedIncidentsEpic(context));
        epicarray.push(fetchCreateInteractionsEpic(context));
        epicarray.push(fetchUpdateIncidentsEpic(context));
        //epicarray.push(clearSNCallerDetailsEpic(context));
        epicarray.push(clearUpdateIncidentEpic(context));
    }

    //Check for Incidents 
    if(tabconfig.incidents) {
        epicarray.push(fetchIncidentsEpic(context));
        epicarray.push(clearIncidentsEpic(context));
    }

    //Check for Interactions 
    if(tabconfig.interactions) {
        epicarray.push(fetchInteractionsEpic(context));
        epicarray.push(clearInteractionsEpic(context));
    }

    // Add pushCallDataRecord to Epic
    epicarray.push(pushCallRecord(context))

    // Add storeDispositionCode to Epic
    epicarray.push(storeDispositionCode(context))

    //Check is BTG feature is Enabled
    // Removing btg check for gender Identity
    // if (btg_config.btgenable) {
        epicarray.push(fetchPatientSearchInfo(context));
        epicarray.push(clearPatientSearchEpic(context));
    // }
    //Adding Setsession Epic
    epicarray.push(fetchSetSessionEpic(context))
    epicarray.push(clearSetSessionEpic(context))

    //Adding Getsession Epic
    epicarray.push(fetchGetSessionEpic(context))
    //epicarray.push(clearGetSessionEpic(context))
    //epicarray.push(clearSelectedSubSessionEpic(context))
    //epicarray.push(clearSelectedSourceSessionEpic(context))

    epicarray.push(fetchEndSessionEpic(context))
    epicarray.push(clearEndSessionEpic(context))

    if (tabconfig.callhistory) {
        epicarray.push(runReportEpic(context));
        epicarray.push(fetchReportResultEpic(context));
    }

    return epicarray;
}

const activeCernerEpics = (context: any) => {
    const { settings } = context;
    const { uisettings: { tabconfig, search,callingdestinationcard,btg_config, consolidated_api_invocation  } } = settings;


    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

    if(consolidated_api_invocation)
    {
        epicArray.push(fetchDashboardApi(context));
    }
    epicArray.push(fetchPatientsCerner(context));
    epicArray.push(fetchPatientSearchInfo_Cerner(context));
    epicArray.push(clearPatientSearchCerner(context));
    epicArray.push(fetchApptsCerner(context));
    epicArray.push(clearAppointmentsCerner(context));
    epicArray.push(clearAppointmentsonPatientChangeCerner(context));
    // epicArray.push(pushConfirmApptToCerner(context));
    epicArray.push(pushCancelApptToCerner(context))
    epicArray.push(fetchPCPCerner(context));
    epicArray.push(clearErrorCerner(context));
    epicArray.push(fetchPendingRefCerner(context));
    epicArray.push(fetchBillingDetailsFromCerner(context));
    epicArray.push(clearBillingCerner(context));
    epicArray.push(fetchInsuranceDetailsFromCerner(context));
    epicArray.push(clearInsuranceCerner(context));
    epicArray.push(clearFHIRInsuranceCerner(context));
    epicArray.push(fetchPharmacyCerner(context));
    epicArray.push(fetchMedicalHistoryCerner(context));
    epicArray.push(clearMedicalHistoryCerner(context));
    epicArray.push(pushUpcomingApptsCerner(context));
    epicArray.push(clearUpcomingApptCerner(context));
    epicArray.push(pushApptsTableCerner(context));
    epicArray.push(fetchAllergiesCerner(context));
    epicArray.push(fetchMedicationCerner(context));
    epicArray.push(pushBillingDetailsToStateCerner(context))
    epicArray.push(pushSelectedBillingDataCerner(context))
    epicArray.push(pushPendingBillsToStateCerner(context));
    epicArray.push(clearPendingRefCerner(context));
    epicArray.push(clearPendingBillsCerner(context));
    epicArray.push(clearMedicationCerner(context));
    epicArray.push(clearPendingBillsAthena(context)),
    epicArray.push(pushPendingBillsToStateAthena(context))
    

    
     // check for the patient global search is enbaled
     if (search.patient) {
        epicArray.push(fetchPatientsGlobalSearchCerner(context));
        epicArray.push(resetSpinForPateintGlobalSearchCerner(context));
    }
    //epicArray.push(fetchLiveSearchEpic(context))
    return epicArray;

}
const activeAthenaEpics = (context: any) => {
    const { settings } = context;
    const { uisettings: { 
            consolidated_api_invocation, 
            dashboardapiconfig 
        } 
    } = settings;

    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

    if(consolidated_api_invocation)
    {
        epicArray.push(fetchDashboardApi(context));
    }

    epicArray.push(fetchPatientsAthena(context));

    if (dashboardapiconfig.getpcp) {
        epicArray.push(fetchPCPAthena(context));
        epicArray.push(clearPCPAthena(context));
    }

    epicArray.push(clearErrorAthena(context));  // duplicated with Epic, should be removed 

    if (dashboardapiconfig.getpendingreferrals) {
        epicArray.push(fetchPendingRefAthena(context));
        epicArray.push(clearPendingRefEpic(context));
    }

    if (dashboardapiconfig.patientappointment) {
        epicArray.push(fetchApptsAthena(context));
        epicArray.push(pushApptsTableAthena(context));
        epicArray.push(clearAppointmentsAthena(context));
        epicArray.push(clearAppointmentsonPatientChangeAthena(context));
        epicArray.push(pushUpcomingApptsAthena(context));
        epicArray.push(clearUpcomingApptAthena(context));
        epicArray.push(pushCancelApptToAthena(context));
        epicArray.push(pushConfirmApptToAthena(context))
    }

    if (dashboardapiconfig.insurance) {
        epicArray.push(fetchInsuranceDetailsFromAthena(context));
        epicArray.push(clearInsuranceAthena(context));
    }

    if (dashboardapiconfig.getproviderinfo) {
        epicArray.push(fetchProviderInfoAthena(context));
    }

    if (dashboardapiconfig.getdeptinfo) {
        epicArray.push(fetchGetDeptInfoAthena(context));
        epicArray.push(clearGetDeptInfoAthena(context));
    }
    epicArray.push(fetchGetAllDepartmentsAthena(context));
    epicArray.push(fetchGetAllProvidersAthena(context));
    epicArray.push(fetchGetAllVisitTypesAthena(context));
    epicArray.push(fetchGetAllTimeSlotsAthena(context));
    epicArray.push(fetchRescheduleAppointmentAthena(context));

    if (dashboardapiconfig.getappoitmentreasoncodes) {
        epicArray.push(fetchGetApptReasonAthena(context));
        epicArray.push(clearApptReasonAthena(context));
    }

    if (dashboardapiconfig.patientsearch) {
        epicArray.push(fetchPatientsGlobalSearchAthena(context));
        epicArray.push(resetSpinForPateintGlobalSearchathena(context));
    }
    
    if (dashboardapiconfig.medication) {
        epicArray.push(fetchMedicationAthena(context));
        epicArray.push(clearMedicationAthena(context));
    }

    if (dashboardapiconfig.getpharmacy) {
        epicArray.push(fetchPharmacyAthenaEpic(context));
        epicArray.push(clearPharmacyAthenaEpic(context));
    }

    if (dashboardapiconfig.activeallergies) {
        epicArray.push(fetchAllergiesAthena(context));
        epicArray.push(clearAllergiesAthena(context));
    }

    if (dashboardapiconfig.medicalhistory) {
        epicArray.push(fetchMedicalHistoryAthena(context));
        epicArray.push(clearMedicalHistoryAthena(context));
    }

    if (dashboardapiconfig.billing) {
        epicArray.push(fetchBillingDetailsFromAthena(context));
        epicArray.push(pushBillingDetailsToStateAthena(context));
        epicArray.push(pushSelectedBillingDataAthena(context));
        epicArray.push(clearBillingAthena(context));
    }

    if (dashboardapiconfig.activeproblems) {
        epicArray.push(fetchActiveProblemAthena(context));
        epicArray.push(clearActiveProblemAthena(context));
    }
    
    //epicArray.push(fetchLiveSearchEpic(context))
    return epicArray;
}

const activeMeditechEpics = (context: any) => {
    const { settings } = context;
    const { uisettings: { 
            consolidated_api_invocation, 
            dashboardapiconfig 
        } 
    } = settings;

    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

    if (dashboardapiconfig.patientappointment) {
        epicArray.push(fetchApptsMeditech(context));
        epicArray.push(pushApptsTableMeditech(context))
        epicArray.push(pushConfirmApptToMeditech(context));
        epicArray.push(pushUpcomingApptsMeditech(context));
        epicArray.push(clearUpcomingApptMeditech(context))
        epicArray.push(pushCancelApptToMeditech(context))
    }
    epicArray.push(fetchPatientsMeditech(context));
    epicArray.push(fetchPCPMeditech(context));
    epicArray.push(clearPCPMeditech(context))
    epicArray.push(fetchPatientsGlobalSearchMeditech(context));
    epicArray.push(resetSpinForPateintGlobalSearchMeditech(context));
    epicArray.push(fetchMedicationMeditech(context));
    //epicArray.push(fetchLiveSearchEpic(context))
    return epicArray;
}
const activeNextgenEpics = (context: any) => {
    const { settings } = context;
    const { uisettings: { tabconfig,
            consolidated_api_invocation, 
            dashboardapiconfig 
        } 
    } = settings;

    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

  

    epicArray.push(fetchPatientsNextgen(context));

    epicArray.push(fetchPatientsGlobalSearchNextgen(context));
    epicArray.push(resetSpinForPateintGlobalSearchNextgen(context));

    if (dashboardapiconfig.getpcp) {
        epicArray.push(fetchPCPNextgen(context));
        epicArray.push(clearPCPNextgen(context));
    }
    if (dashboardapiconfig.patientappointment) {

    epicArray.push(fetchApptsNextgen(context))
    epicArray.push(pushApptsTableNextgen(context))
    epicArray.push(pushUpcomingApptsNextgen(context));
    epicArray.push(clearUpcomingApptNextgen(context));
    }
    epicArray.push(fetchBillingDetailsFromNextGen(context));
    epicArray.push(pushBillingDetailsToStateNextGen(context));
    epicArray.push(pushSelectedBillingDataNextGen(context));
    epicArray.push(clearBillingNextGen(context));
    epicArray.push(pushPendingBillsToStateNextGen(context));

    if (tabconfig.triage) {
        epicArray.push(fetchAllergiesNextgen(context));
        epicArray.push(clearAllergiesNextgen(context));
    }
    if(tabconfig.medication) {
        epicArray.push(fetchMedicationNextgen(context));
        epicArray.push(clearMedicationNextgen(context));
    }

    epicArray.push(fetchInsuranceDetailsFromNextgen(context))

    if(tabconfig.emergencycontact) {
        epicArray.push(fetchEmergencyContactNextgen(context))
        epicArray.push(clearEmergencyContactNextgen(context))
    }

    //epicArray.push(fetchLiveSearchEpic(context))
    return epicArray;
}

const activeECWAPI = (context: any) => {
    const { settings } = context;
    const { uisettings: { tabconfig,
            consolidated_api_invocation, 
            dashboardapiconfig 
        } 
    } = settings;

    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

    epicArray.push(fetchPatientsECW(context));
    epicArray.push(fetchPatientsGlobalSearchECW(context));
    epicArray.push(resetSpinForPateintGlobalSearchecw(context))
    return epicArray;
}

const commonEpics = (context: any) => {
    const { settings } = context;
    const { 
        uisettings: { 
            agent_notes
        }
    } = settings;

    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicArray: any = [];

    if (agent_notes.display) {
        epicArray.push(fetchNotesHistoryEpic(context));
        epicArray.push(addNotesHistoryEpic(context));
        epicArray.push(clearNotesEpic(context));
    }

    epicArray.push(fetchLiveSearchEpic(context));
    epicArray.push(fetchPanvivaUserID(context));
    epicArray.push(fetchUpdatePanvivaID(context));
    epicArray.push(niceClickToTransfer(context))

    return epicArray;
}

/**
 * This Function will combine all active epics
 * @param context contains setting json etc..
 */
export const build = (context: any) => (
    combineEpics(
        ...activeepics(context),
        ...activeCernerEpics(context),
        ...activeAthenaEpics(context),
        ...activeMeditechEpics(context),
        ...activeNextgenEpics(context),
        ...activeECWAPI(context),
        ...commonEpics(context)
    )
);